import { app } from './checkpointHelper/app';
import { isSecondaryCheckpointUser } from './checkpointHelper/static/auth-types';
import { isPrimaryCheckpointUser } from './settings/authz';
import { SETTINGS_APP_NAME } from './settings/config';

const ROLE_LABELS: Record<string, string> = {
    admin: 'Administrator',
    manager: 'Manager',
    maintainer: 'Maintainer',
    developer: 'Developer',
    author: 'Author',
    editor: 'Editor',
    tester: 'Tester',
    agent: 'Agent',
};

function formatRole(role: string | null | undefined): string {
    if (!role) {
        return 'User';
    }
    const key = role.toLowerCase();
    return ROLE_LABELS[key] ?? role.charAt(0).toUpperCase() + role.slice(1);
}

function displayName(): string {
    const user = app.window.user;
    const member = app.window.member;

    if (isPrimaryCheckpointUser()) {
        const primaryName = user.username?.trim() || user.email.trim();
        return primaryName || String(member.username ?? member.email ?? 'User');
    }

    if (isSecondaryCheckpointUser(user)) {
        return user.username.trim()
            || user.email.trim()
            || String(member.username ?? member.email ?? 'User');
    }

    return String(member.username ?? member.email ?? 'User');
}

function userInitials(name: string): string {
    const trimmed = name.trim();
    if (!trimmed) {
        return '?';
    }
    const parts = trimmed.split(/\s+/).filter(Boolean);
    if (parts.length >= 2) {
        return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
    }
    return trimmed.slice(0, 2).toUpperCase();
}

function appRoleLabel(): string {
    if (isPrimaryCheckpointUser()) {
        return 'Administrator';
    }

    if (isSecondaryCheckpointUser(app.window.user)) {
        return formatRole(app.window.user.apps[SETTINGS_APP_NAME]?.role);
    }

    return 'User';
}

/** Updates navbar user avatar, name, and role from app.window.user and app.window.member. */
export function updateUserAccountNav(): void {
    const name = displayName();
    const role = appRoleLabel();
    const initials = userInitials(name);

    document.querySelectorAll('.user-account .avatar').forEach((el) => {
        el.textContent = initials;
    });
    document.querySelectorAll('.js-user-account-name').forEach((el) => {
        el.textContent = name;
    });
    document.querySelectorAll('.js-user-account-role').forEach((el) => {
        el.textContent = role;
    });
}
